













































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { Button, Field, Popup, Picker, Cell, CellGroup } from "vant";
import CustomSelect from "./components/CustomSelect.vue";

@Component({
  name: "PersonalInfoSupply",
  components: {
    [Button.name]: Button,
    [Field.name]: Field,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    customSelect: CustomSelect
  }
})
export default class PersonalInfoSupply extends Vue {
  form = {
    user_phone: "",
    email: "",
    education: "",
    job_type: "1",
    open_type: 1,
    country_id: 1
  };

  employmentForm = {
    company: "",
    vocation_attribute: "",
    vocation: "",
    job_age: "",
    company_address: "",
    company_phone: ""
  };

  otherForm = {
    job_type_other_describe: ""
  };
  zone_code = "";

  educationText = "";
  showEducationPicker = false;
  educationColumns: any = [];

  employmentText = "";
  showEmploymentPicker = false;
  employmentColumns: any = [];

  jobAgeText = "";
  showJobAgePicker = false;
  jobAgeColumns: any = [];

  @Watch("form.education")
  watchFormEducation(val) {
    const column = this.educationColumns.find((item) => {
      return item.value == val;
    });
    
    this.educationText = (column && column.text) || "";
  }

  @Watch("form.job_type")
  watchFormEmployment(val) {
    const column = this.employmentColumns.find((item) => {
      return item.value == val;
    });
    
    this.employmentText = (column && column.text) || "";
  }

  @Watch("form.job_age")
  watchFormJobAge(val) {
    const column = this.jobAgeColumns.find((item) => {
      return item.value == val;
    });
    
    this.jobAgeText = (column && column.text) || "";
  }
  get bgColor() {
    return this.$store.getters["common/bgColor"];
  }

  get computedPhone() {
    return `+${this.zone_code} ${this.form.user_phone}`;
  }

  get isSubmitDisabled() {
    const formDisabled =
      !this.form.education || !this.form.job_type || !this.form.email;
    if (this.isEmployee) {
      return (
        formDisabled ||
        !(
          this.employmentForm.company &&
          this.employmentForm.vocation_attribute &&
          this.employmentForm.vocation &&
          this.employmentForm.job_age
        )
      );
    } else if (this.isOther) {
      return formDisabled || !this.otherForm.job_type_other_describe;
    } else {
      return formDisabled;
    }
  }

  get isEmployee() {
    return this.form.job_type == "1" || this.form.job_type == "2";
  }

  get isOther() {
    return this.form.job_type == "5";
  }

  created() {
    this.educationColumns = this.$t(
      "open_account.personal_info_supply.education_field.columns"
    );
    this.employmentColumns = this.$t(
      "open_account.personal_info_supply.employment_field.columns"
    );
    this.jobAgeColumns = this.$t(
      "open_account.personal_info_supply.employment_duration_field.columns"
    );
  }

  activated() {
    const userInfo = (this as any).$localstorage.get("userInfo");
    const { phone, zone_code, email } = userInfo;
    this.zone_code = zone_code;
    this.form.user_phone = phone;
    this.form.email = email;
    if (typeof this.$route.query.open_type == "string") {
      this.form.country_id =
        (this.$route.query.open_status &&
          Number(this.$route.query.open_status)) ||
        1;
      this.form.open_type =
        (this.$route.query.open_type && Number(this.$route.query.open_type)) ||
        1;
    }
  }

  handEmailBind() {
    this.$router.push({
      path: "/email-bind"
    });
  }

  handleConfirmEducation(item) {
    
    this.form.education = item.value;
    this.showEducationPicker = false;
  }

  handleConfirmEmployment(item) {
    
    this.form.job_type = item.value;
    this.showEmploymentPicker = false;
  }

  handleConfirmJobAge(item) {
    
    this.employmentForm.job_age = item.value;
    this.showJobAgePicker = false;
  }

  handleSavePersonalInfo() {
    let params = {};
    if (this.isEmployee) {
      params = {
        ...this.form,
        ...this.employmentForm
      };
    } else if (this.isOther) {
      params = {
        ...this.form,
        ...this.otherForm
      };
    } else {
      params = this.form;
    }
    (this as any).$apis
      .savePersonalInfo(params)
      .then((res) => {
        
        this.$router.push({
          path: "/customer-state",
          query: this.$route.query
        });
      })
      .catch((e) => {
        
      });
  }
}
